import { Icon } from 'app/assets/icons'
import { Text } from 'app/common/typography'
import React from 'react'
import { colors } from 'shared/assets/styles'
import type { Reward } from 'shared/types'
import styled from 'styled-components'

const { grey, veryLightYellow } = colors

type Props = {
    reward: Reward
}

const BlazonReward = (props: Props) => {
    const { reward } = props
    const { iconCode, description } = reward

    return (
        <Container>
            <IconContainer>
                <Icon color="black" code={iconCode} size={24} />
            </IconContainer>
            <Description>{description}</Description>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 8px;
    background-color: ${veryLightYellow};
    align-items: center;
`

const IconContainer = styled.div`
    width: 24px;
    height: 24px;
`

const Description = styled(Text)`
    white-space: pre-line;
    color: ${grey};
`

export { BlazonReward }
